import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { RequiredDocumentsUpload } from '@/features/my-onboarding/required-documents-upload'

export const Route = createFileRoute(
  '/_authenticated/_organization/onboarding/required-documents'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: RequiredDocumentsRoute,
})

function RequiredDocumentsRoute() {
  return (
    <Main className='flex flex-1 flex-col gap-6'>
      <RequiredDocumentsUpload />
    </Main>
  )
}
